export enum CreateTeamActions {
  SET_MODAL = "@@create_teams/SHOW_MODAL",
  SET_SLECTED_TEMPLATE_ID = "@@create_teams/SET_SLECTED_TEMPLATE_ID",
  SET_SLECTED_MATTER_ID = "@@create_teams/SET_SLECTED_MATTER_ID",
}
